module.exports = __webpack_public_path__ + "img/ic_dashboard_medal_silver.d0e83e42.svg";